import { Injectable } from '@angular/core';
import { Observable, tap, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InfoTransacaoModel, InfoTransacaoModelResponse, ITransacoes } from '../subFrota/model/abastecimentos-view-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from '../services/localstorage.service';
import { SnackBarService } from '../services/snack-bar-service.service';
import { LoginModel } from '../model/login.model';
import { IFiltroRegistroTransacoesViewModel } from '../relatorios/model/filtro-transacoes-view-model';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class RegistroTransacoesService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  public usuario!: LoginModel;


  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private snackBar: SnackBarService) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  
  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }
  
  obterListaTransacoes(filtro: IFiltroRegistroTransacoesViewModel): Observable<ITransacoes>{
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ListaRegistroOperacoes;

    return this.http.post<ITransacoes>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as transacoes da Frota.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<ITransacoes>('Não foi possível consultar as transacoes da Frota.', {sucesso : false, retorno: [], mensagens: []}))
    );
  }

  obterImagemTransacao(data: InfoTransacaoModel): Observable<InfoTransacaoModelResponse> {
    const url = environment.host_ctf_service + CONFIG_URLS_API.API_ObterImagemTransacao;

    return this.http.post<InfoTransacaoModelResponse>(url, data, this.httpOptions).pipe(
      tap((response: InfoTransacaoModelResponse) => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível obter a imagem do Hodômetro.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<InfoTransacaoModelResponse>(
        'Não foi possível obter a imagem do Hodômetro.',
        { sucesso: false, retorno: undefined, mensagens: [] }
      ))
    );
  }

}
